import { TrendingUp } from "lucide-react";

const DAYS = ["M", "T", "W", "T", "F", "S", "S"];

function Stat({ label, value, accent, testid }) {
  return (
    <div>
      <div className={`text-2xl font-black font-display ${accent ? "pv-text-primary" : "text-white"}`} data-testid={testid}>{value}</div>
      <div className="text-[10px] uppercase tracking-wider text-white/40 font-bold">{label}</div>
    </div>
  );
}

export default function WeeklyPerformance({ weekly }) {
  const max = Math.max(1, ...weekly.chart);
  return (
    <section className="rounded-2xl pv-bg-dark text-white p-5" data-testid="weekly-performance-card">
      <div className="flex items-center justify-between">
        <span className="text-xs font-black uppercase tracking-widest text-white/50">This Week</span>
        <span className="inline-flex items-center gap-1 text-xs font-bold pv-text-primary"><TrendingUp size={14} />+{weekly.dupr_delta.toFixed(2)} DUPR</span>
      </div>
      <div className="grid grid-cols-4 gap-3 mt-4">
        <Stat label="Games" value={weekly.games} />
        <Stat label="Wins" value={weekly.wins} />
        <Stat label="Win %" value={`${weekly.win_rate}%`} accent testid="weekly-win-rate" />
        <Stat label="Hours" value={weekly.hours} />
      </div>
      <div className="mt-4" data-testid="weekly-chart">
        <div className="flex items-end gap-1.5 h-16">
          {weekly.chart.map((c, i) => (
            <div key={i} className="flex-1 rounded-t bg-[#BED445]" style={{ height: `${Math.max(6, (c / max) * 100)}%`, opacity: c ? 1 : 0.25 }} />
          ))}
        </div>
        <div className="flex gap-1.5 mt-1">
          {DAYS.map((d, i) => (
            <span key={i} className="flex-1 text-center text-[9px] text-white/40">{d}</span>
          ))}
        </div>
      </div>
      <p className="text-sm font-semibold pv-text-primary mt-3">{weekly.insight}</p>
    </section>
  );
}
